// Scroll Indicator Script
document.addEventListener('DOMContentLoaded', function() {
  // Fungsi untuk mendapatkan teks berdasarkan bahasa
  function getScrollText() {
    const lang = document.documentElement.lang || 'en';
    const translations = {
      'id': 'Scroll untuk info lebih',
      'en': 'Scroll to know more',
      'fr': 'Défiler pour en savoir plus',
      'es': 'Desplácese para saber más',
      'de': 'Scrollen für mehr Infos',
      'it': 'Scorri per saperne di più',
      'ja': 'スクロールして詳細を見る',
      'ko': '더 알아보려면 스크롤하세요',
      'zh-CN': '滚动了解更多',
      'ru': 'Прокрутите для подробностей'
    };
    
    return translations[lang] || translations['en'];
  }

  // Hanya tampilkan di halaman produk
  if (!document.querySelector('.scroll-indicator-init')) {
    return;
  }
  
  // Buat elemen tombol scroll
  const scrollButton = document.createElement('div');
  scrollButton.className = 'scroll-indicator';
  scrollButton.innerHTML = `
    <span class="scroll-indicator__text">${getScrollText()}</span>
    <span class="scroll-indicator__icon">↓</span>
  `;
  
  // Tambahkan ke body
  document.body.appendChild(scrollButton);
  
  // Tampilkan tombol setelah delay singkat
  setTimeout(() => {
    scrollButton.classList.add('visible');
  }, 2000);
  
  // Sembunyikan tombol ketika user scroll
  let scrollTimeout;
  let hasScrolled = false;
  
  window.addEventListener('scroll', function() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    
    // Jika user sudah scroll cukup jauh (25% dari tinggi viewport)
    if (scrollPosition > window.innerHeight * 0.25) {
      scrollButton.classList.add('hidden');
      hasScrolled = true;
    } else if (!hasScrolled) {
      // Jika user belum scroll jauh dan belum pernah scroll jauh sebelumnya
      scrollButton.classList.remove('hidden');
    }
    
    // Sembunyikan tombol setelah 5 detik tidak ada aktivitas scroll
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      if (scrollPosition < window.innerHeight * 0.25 && !hasScrolled) {
        scrollButton.classList.remove('hidden');
      }
    }, 5000);
  });
  
  // Scroll halus ke bawah saat tombol diklik
  scrollButton.addEventListener('click', function() {
    const targetPosition = window.innerHeight * 0.5;
    
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
    
    // Tandai bahwa user telah scroll
    hasScrolled = true;
    
    // Sembunyikan tombol
    scrollButton.classList.add('hidden');
  });
});
